import { render } from "./Flare.vue?vue&type=template&id=e01bd9fc"
import script from "./Flare.vue?vue&type=script&lang=js"
export * from "./Flare.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Flare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e01bd9fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e01bd9fc', __exports__)) {
    api.reload('e01bd9fc', __exports__)
  }
  
  module.hot.accept("./Flare.vue?vue&type=template&id=e01bd9fc", () => {
    api.rerender('e01bd9fc', render)
  })

}


export default __exports__